/* Balkan — rafturile cu derulare pe orizontala: tragere cu degetul sau cu mouse-ul.

   Pe telefon derularea cu degetul exista nativ. Pe desktop NU: raftul se putea
   misca doar din sageti sau cu shift+rotita, ceea ce nu se ghiceste. Aici
   adaugam tragerea cu mouse-ul, iar bara de derulare o ascundem din CSS.

   ⚠️ Dupa o tragere, clicul de pe card trebuie ANULAT: altfel omul trage raftul
   si ajunge pe pagina produsului peste care a ridicat degetul. */
(() => {
  if (window.__bkRail) return;
  window.__bkRail = true;

  const SELECTOARE = '[data-bk-rail], .bk-rail, .bk-com2__rail, .bk-col__chips, .bkann--static .bkann__stage';
  const PRAG = 6; // px de la care miscarea e tragere, nu clic

  const lega = (el) => {
    if (el.dataset.bkDrag) return;
    el.dataset.bkDrag = '1';
    let jos = false, tras = false, x0 = 0, s0 = 0, pid = null;

    /* ⚠️ FAZA DE CAPTURA. Cardurile Horizon opresc propagarea pe `pointerdown`
       pentru gesturile lor, deci pe faza de bubbling evenimentul nu mai ajunge
       niciodata la raft si tragerea nu pornea. */
    el.addEventListener('pointerdown', (e) => {
      /* degetul are deja derulare nativa; nu ne bagam peste ea */
      if (e.pointerType === 'touch' || e.button !== 0) return;
      if (e.target.closest('input, select, textarea')) return;
      /* ⚠️ `is-grab` NU se pune la apasare. Clasa taie `pointer-events` pe
         linkuri, iar browserul calculeaza tinta clicului la ridicare: cu
         linkul dezactivat in timpul apasarii, clicul ajungea pe container si
         cardul nu mai deschidea produsul. Se pune abia cand chiar se trage. */
      jos = true; tras = false; x0 = e.clientX; s0 = el.scrollLeft; pid = e.pointerId;
    }, { capture: true });

    el.addEventListener('pointermove', (e) => {
      if (!jos) return;
      const d = e.clientX - x0;
      if (!tras && Math.abs(d) < PRAG) return;
      if (!tras) {
        tras = true;
        el.classList.add('is-grab');
        try { el.setPointerCapture(pid); } catch {}
        /* ⚠️ `scroll-snap-type: x mandatory` readuce fiecare pas de tragere la
           cel mai apropiat punct de fixare, deci raftul nu se misca deloc.
           Il oprim pe durata tragerii si il punem la loc la final, ca sa
           ramana alinierea pe card la derularea normala si din sageti. */
        el.style.scrollSnapType = 'none';
      }
      e.preventDefault();
      el.scrollLeft = s0 - d;
    }, { capture: true });

    const sus = () => {
      if (!jos) return;
      jos = false;
      el.classList.remove('is-grab');
      el.style.scrollSnapType = '';
      try { el.releasePointerCapture(pid); } catch {}
      if (tras) {
        /* ⚠️ Anularea trebuie DEZARMATA imediat, nu lasata pe `once`.
           O tragere lunga nu produce niciun `click` (tinta de la apasare si cea
           de la ridicare difera), deci ascultatorul ramanea armat si inghitea
           urmatorul clic REAL de pe un card. */
        const taie = (e) => { e.preventDefault(); e.stopPropagation(); };
        el.addEventListener('click', taie, { capture: true });
        setTimeout(() => { el.removeEventListener('click', taie, { capture: true }); tras = false; }, 0);
      }
    };
    el.addEventListener('pointerup', sus, { capture: true });
    el.addEventListener('pointercancel', sus, { capture: true });
    el.addEventListener('dragstart', (e) => { if (tras) e.preventDefault(); });
  };

  const scan = () => document.querySelectorAll(SELECTOARE).forEach(lega);
  scan();
  /* rafturile randate prin Section Rendering API apar mai tarziu.
     ⚠️ PERFORMANȚĂ (15 oct. 2026): înainte, ORICE schimbare din pagină relua căutarea
     în tot documentul (4.300+ elemente) — inclusiv fiecare literă a animației din
     căutare, de ~15 ori pe secundă. Acum: doar când apar ELEMENTE noi, o dată pe cadru. */
  let programat = false;
  const cuElemente = (m) => { for (const n of m.addedNodes) if (n.nodeType === 1) return true; return false; };
  new MutationObserver((muts) => {
    if (programat || !muts.some(cuElemente)) return;
    programat = true;
    requestAnimationFrame(() => { programat = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
